import { Routes, Route, Navigate } from 'react-router-dom';
import { useStore } from './lib/store';
import { supabaseEnabled } from './lib/supabase';
import { Library } from './screens/Library';
import { BookDetail } from './screens/BookDetail';
import { Reader } from './screens/Reader';
import { Search } from './screens/Search';
import { Upload } from './screens/Upload';
import { Auth } from './screens/Auth';
import { Habits } from './screens/Habits';
import { Settings } from './screens/Settings';

export default function App() {
  const session = useStore((s) => s.session);
  const ready = useStore((s) => s.ready);

  if (!ready) return <div className="h-full flex items-center justify-center text-ink-500 text-sm">loading</div>;

  // If Supabase is configured but user isn't signed in, force auth.
  // Otherwise (no Supabase yet) let them use the app fully offline.
  if (supabaseEnabled && !session) {
    return (
      <div className="h-full">
        <Routes>
          <Route path="/auth" element={<Auth />} />
          <Route path="*" element={<Navigate to="/auth" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="h-full">
      <Routes>
        <Route path="/" element={<Library />} />
        <Route path="/book/:id" element={<BookDetail />} />
        <Route path="/read/:id" element={<Reader />} />
        <Route path="/search" element={<Search />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/habits" element={<Habits />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
